import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { AddConfigurationServices } from './addConfiguration.service';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-add-configuration',
  templateUrl: './add-configuration.component.html',
  styleUrls: ['./add-configuration.component.sass']
})
export class AddConfigurationComponent implements OnInit {

  // Add Package Configuration
  helpersBasicAmount:any;
  couponBasicAmount:any;
  tripFareGST:any;
  helperGST:any;
  commissionFee:any;
  commissionFeeGST:any;
  convenienceFee:any;
  convenienceFeeGST:any;
  minimumDistanceForTrip:any;
  helperTDS:any;
  distanceForNotification:any;
  minDate=""
  driverTDS:Number
  constructor(
    private spinner:NgxSpinnerService,
    private addConfigService:AddConfigurationServices,
    private toastr:ToastrService
  ) { }

  ngOnInit(): void {
    const today = new Date();
    this.minDate = today.toISOString().split('T')[0];
  }
  addPackageConfiguration(){
    this.spinner.show()
    let data={
      "helpersBasicAmount":this.helpersBasicAmount,
      "couponBasicAmount":this.couponBasicAmount,
      "tripFareGST":this.tripFareGST,
      "helperGST":this.helperGST,
      "commissionFee":this.commissionFee,
      "commissionFeeGST":this.commissionFeeGST,
      "convenienceFee":this.convenienceFee,
      "convenienceFeeGST":this.convenienceFeeGST,
      "distanceForNotification":this.distanceForNotification,
      "minimumDistanceForTrip":this.minimumDistanceForTrip,
      "helperTDS":this.helperTDS,
      "driverTDS":this.driverTDS
    }
    console.log("reqData", data)
 
    this.addConfigService.addPackageConfig(data).subscribe((result:any)=>{
      if(result.statusCode==200){
        console.log( "packageConfigAdd",result)
        this.spinner.hide();
        this.toastr.success(result.message)
        this.helpersBasicAmount=0;
        this.commissionFee=0;
        this.commissionFeeGST=0;
        this.convenienceFee=0;
        this.convenienceFeeGST=0;
        this.helperGST=0;
        this.helperTDS=0;
        this.driverTDS=0;
        this.couponBasicAmount=0;
        this.tripFareGST;
        this.distanceForNotification;
        this.minimumDistanceForTrip;
      }else{
        this.spinner.hide()
        this.toastr.error(result.message)
      }
    })
  }

  // Add New Range
  minimumDistance:Number;
  maximumDistance:Number;
  range:"";

  addNewRange(){
    this.spinner.show();
    let data={
      "min":this.minimumDistance,
      "max":this.maximumDistance,
      "name":this.range
    }
    this.addConfigService.addRange(data).subscribe((result:any)=>{
      console.log("Add new range", result)
      if(result.statusCode==200){
        this.toastr.success(result.message)
        this.spinner.hide()
      }else if(result.statusCode==400){
        this.toastr.error(result.message)
        this.spinner.hide()
      }else(this.toastr.error(result.message),
      this.spinner.hide())
    })
  }

  // Add new coupan
  coupanCode:"";
  coupanAmount:Number;
  coupanExpiry:"";
  addNewCoupan(){
    this.spinner.show();
    let data={
      "code":this.coupanCode,
      "amount":this.coupanAmount,
      "expiry":this.coupanExpiry
    }
    console.log( "Add New Coupan req", data)
    this.addConfigService.addCoupan(data).subscribe((result:any)=>{
      this.spinner.hide();
      if(result.statusCode==200){
        console.log("addnewCoupan", result)
        this.coupanCode=""
        this.coupanAmount=null
        this.coupanExpiry=""
        this.toastr.success(result.message)
      }else(this.toastr.error(result.message))
    })
  }

  // Add packer mover configuration
  packersMoversLitePrice:any;
  packersMoversLiteStandard:any;
  packersMoversLitePremium:any;
  distanceForNotificationPM:any;

  addPackerMoverConfiguration(){
    this.spinner.show()
    let data={
      "packersMoversLitePrice":this.packersMoversLitePrice,
      "packersMoversLiteStandard":this.packersMoversLiteStandard,
      "packersMoversLitePremium":this.packersMoversLitePremium,
      "distanceForNotification":this.distanceForNotificationPM,
    }
    console.log("reqDataPM", data)
 
    this.addConfigService.addPackerMoverConfig(data).subscribe((result:any)=>{
      if(result.statusCode==200){
        console.log("packerMoverConfigAdd",result)
        this.spinner.hide();
        this.toastr.success(result.message)
        this.packersMoversLitePrice=0;
        this.packersMoversLiteStandard=0;
        this.packersMoversLitePremium=0;
        this.distanceForNotificationPM=0;
      }else{
        this.spinner.hide()
        this.toastr.error(result.message)
      }
    })
  }


  // Add Appication configuration

  mobileNoContactUs:any
  emailIdHelp:any;
  splashScreenTime:any;
  helpLineNo:any
  userAppVersion:any;
  driverAppVersion:any;
  userAppUpdates:any;
  driverAppUpdates:any;
  versionDriverImage:any;
  versionUserImage:any;
  driverWalletMinimumAmount:Number;

  isBillDetails:false;
  isHelperActive:false;
  isPayOnDelivery:false;
  isOnlinePay:true;
  addApplicationConfiguration(){
    this.spinner.show();
    let data={
      "mobileNoContactUs":this.mobileNoContactUs,
      "emailIdHelp":this.emailIdHelp,
      "splashScreenTime":this.splashScreenTime,
      "helpLineNo":this.helpLineNo,
      "userAppVersion":this.userAppVersion,
      "driverAppVersion":this.driverAppVersion,
      "userAppUpdates":this.userAppUpdates,
      "driverAppUpdates":this.driverAppUpdates,
      "versionDriverImage":this.versionDriverImage,
      "versionUserImage":this.versionUserImage,
      "isBillDetails":this.isBillDetails,
      "isHelperActive":this.isHelperActive,
      "isPayOnDelivery":this.isPayOnDelivery,
      "driverWalletMinimumAmount":this.driverWalletMinimumAmount
    }
    console.log("Application Config", data)
    this.addConfigService.addApplicationConfig(data).subscribe((result:any)=>{
      this.spinner.hide()
      if(result.statusCode==200){
        console.log("addAppConfig", result)
        this.toastr.success(result.message)
      }else{
        this.toastr.error(result.message)
      }
    })
  }
  billdetailsVisible(value){
    this.isBillDetails = value;
    console.log("Bill Details", this.isBillDetails)
  }
  heplerActive(value){
    this.isHelperActive=value
    console.log( "Helper Active",this.isHelperActive)
  }
  payOnDel(value){
    this.isPayOnDelivery=value;
    console.log("Pay on Delivery", this.isPayOnDelivery)
  }
  OnlinePay(value){
    this.isOnlinePay=value;
    console.log("Online Pay", this.isOnlinePay)
  }

  // Add QR Configuration
  mode:any;
  mc:any;
  qrMedium:any;
  tn:any;
  pn:any;
  pa:any;
  addQRConfiguration(){
    this.spinner.show()
    let data={
      "mode":this.mode,
      "mc":this.mc,
      "qrMedium":this.qrMedium,
      "tn":this.tn,
      "pn":this.pn,
      "pa":this.pa
    }
    this.addConfigService.addQrConfig(data).subscribe((result:any)=>{
      if(result.statusCode==200){
        this.spinner.hide()
        this.toastr.success(result.message)
        this.mode="";
        this.mc="";
        this.qrMedium="";
        this.tn="";
        this.pn="";
        this.pa="";
      }else{
        this.spinner.hide()
        this.toastr.error(result.message)
      }
    })
  }
}
